import "./App.css";
import Sidebar from "./components/sidebar/Sidebar";
import MainWrapper from "./components/main/Main";

function App() {
  return (
    <div>
      <div className="pointer-events-none fixed inset-0 z-30 transition duration-300 lg:absolute" />
      <div
        className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
        aria-hidden="true"
      >
        <div className="animate-blob absolute -left-24 top-0 h-72 w-72 rounded-full bg-fuchsia-500/20 blur-3xl md:h-96 md:w-96" />
        <div className="animate-blob absolute right-0 top-1/3 h-72 w-72 rounded-full bg-teal-400/20 blur-3xl [animation-delay:6s] md:h-96 md:w-96" />
        <div className="animate-blob absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-indigo-500/20 blur-3xl [animation-delay:12s] md:h-96 md:w-96" />
      </div>
      <div className="relative z-10 mx-auto min-h-screen max-w-screen-xl px-6 py-12 font-sans md:px-12 md:py-20 lg:px-24 lg:py-0">
        <div className="lg:flex lg:justify-between lg:gap-4">
          <Sidebar />
          <MainWrapper />
        </div>
      </div>
    </div>
  );
}

export default App;
